import React from 'react';
import { getImageSrc } from '../../../util';

type Props = {
  className?: string;
};

export const AboutMission: React.FC<Props> = props => {
  return (
    <>
      <div className={`${props.className}`}>
        <div className={'flex'}>
          <div
            className={
              'grid gap-y-6 grid-cols-1 md:grid-cols-8 md:gap-x-6 md:items-center'
            }
          >
            <div
              className={
                'row-start-2 md:row-start-1 md:col-start-1 md:col-span-4 md:mr-6 lg:mr-16 2xl:mr-20 xl:mr-20'
              }
            >
              <div>
                <span className="mt-2 text-2xl font-semibold  text-gray-900 sm:text-3xl lg:text-4xl ">
                  <span className="block text-gray-900">
                    Our mission is simple:
                  </span>
                  <span className={'block text-primary-600'}>
                    we help restaurants bounce back.
                  </span>
                </span>
                <p className="text-lg  sm:text-lg text-left md:text-lg text-gray-900 mt-4 xl:mt-6">
                  We started TableTab in 2019 after seeing restaurants struggle
                  to survive (this was pre-COVID). We knew first-hand, with
                  Greg's family running their own restaurant, how rising costs
                  have forced businesses nationwide to close.
                </p>
                <p className="text-lg  sm:text-lg text-left md:text-lg text-gray-900 mt-2 xl:mt-4">
                  TableTab was born from the belief that restaurants can run a
                  more profitable operation while improving the dining
                  experience. With the right system, businesses can serve their
                  guests better without worrying about next month's rent. So we
                  built that system.
                </p>
                <div className="mt-10 sm:mt-12 w-1/10  justify-start">
                  <a
                    href="/product"
                    className="items-center justify-start px-6 py-2 border border-transparent text-base font-medium rounded-full text-white bg-primary-600 hover:bg-primary-700 hover:text-white"
                  >
                    Check it out
                  </a>
                </div>
              </div>
            </div>
            <div
              className={`bg-blue-200 w-full sm:w-full md:w-full xl:w-full lg:w-full 2xl:w-full mx-auto md:mx-0  rounded-xl shadow-md ${'md:col-start-5 row-start-1 md:col-span-4'}`}
            >
              <div className={''}>
                <picture className="lazyload">
                  <source
                    srcSet={getImageSrc('FounderswithYuka.webp')}
                    type="image/webp"
                  />
                  <source
                    srcSet={getImageSrc('FounderswithYuka.jpg')}
                    type="image/jpeg"
                  />
                  <img
                    className={'rounded-xl shadow-lg lazyload'}
                    data-src={getImageSrc('FounderswithYuka.webp')}
                    alt={'partner photo'}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
